/* eslint-disable react/display-name */
import { MapPin } from 'lucide-react';
import React from 'react';
import Button from '../../../../ComponentsV1/Button';
import { MetricsForJumboEvent } from '../../../../../analytics/constants';
import { SeeMapClickEvent } from '../../../../../analytics/address-view/events';

export const InitialMapViewV1 = React.memo(
  ({ refreshMap, orderId, userId }) => {
    return (
      <div
        className={
          'tw-h-full tw-w-full tw-flex tw-items-center tw-justify-center tw-min-h-[6rem]'
        }
      >
        <div className='bgImg' />
        <div className='tw-flex tw-h-full tw-w-full tw-justify-center tw-p-2'>
          <div className='tw-flex tw-items-center tw-gap-4 tw-justify-between'>
            <div className='tw-flex tw-items-center tw-justify-between tw-gap-2'>
              <div className='tw-flex tw-flex-col'>
                <p className='tw-text-300 tw-font-medium tw-text-zinc-500 tw-leading-tight tw-whitespace-nowrap'>
                  Track delivery
                </p>
                <p className='tw-text-300 tw-font-medium tw-text-zinc-500 tw-leading-tight tw-whitespace-nowrap'>
                  partner&#39;s live location
                </p>
              </div>
            </div>
            <Button
              onClick={() => {
                SeeMapClickEvent({
                  [MetricsForJumboEvent.order_id]: orderId,
                  [MetricsForJumboEvent.customer_id]: userId,
                });
                refreshMap();
              }}
              title={
                <div className='tw-flex tw-items-center tw-gap-1'>
                  See Map
                  <MapPin size={13} strokeWidth={2.5} />
                </div>
              }
              key='see-map-button'
              size='small'
              type='outline'
            />
          </div>
        </div>
      </div>
    );
  },
);
